/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Role_Org_User7Inputs */

const en__field__enum_role_org_user7 = /** @type {(inputs: _Field__Enum_Role_Org_User7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization user`)
};

/** @type {(inputs: _Field__Enum_Role_Org_User7Inputs) => LocalizedString} */
const de__field__enum_role_org_user7 = en__field__enum_role_org_user7;

/**
* | output |
* | --- |
* | "Organization user" |
*
* @param {_Field__Enum_Role_Org_User7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_role_org_user7 = /** @type {((inputs?: _Field__Enum_Role_Org_User7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Role_Org_User7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_role_org_user7(inputs)
	return de__field__enum_role_org_user7(inputs)
});
export { _field__enum_role_org_user7 as "_field__enum_role_ORG_USER" }